// Controle de acesso do Dashboard TNP (monitoramento de isenção IR — atendente Katiusia).
// Regra: o painel só fica visível/abrível para o time da TNP.
//
// ATENÇÃO ao naming traiçoeiro do CRM: o que o backend chama de `id_time`
// é persistido no front, no localStorage, com a chave `id_cliente`.
// Portanto "146" aqui é o id_time da TNP, lido via localStorage.getItem("id_cliente").
export const DASHBOARD_TNP_ID_CLIENTE = "146";

export const canViewDashboardTnp = (): boolean =>
  localStorage.getItem("id_cliente") === DASHBOARD_TNP_ID_CLIENTE;
